module.exports = __webpack_public_path__ + "cristmas.f820562ae2d920b76344.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/christmas/webfont/cristmas.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/christmas/webfont/cristmas.ttf
// module chunks = styles